import { PortalNewsPageObjClass } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"
import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { useScrivitoPortalNewsListModel } from "widgets/portal-news-list/model/useScrivitoPortalNewsListModel"

import { PortalNewsOverlayModel } from "../PortalNewsOverlayConnector"

export function usePortalNewsOverlayModel(): PortalNewsOverlayModel {
  const { closeOverlay } = useCurrentOverlay()

  const portalNewsPage = PortalNewsPageObjClass.where(
    "isPrimary",
    "equals",
    true
  ).first()

  const listModel = useScrivitoPortalNewsListModel({ page: portalNewsPage })

  return { page: portalNewsPage, listModel, onClose: closeOverlay }
}
